import { Divider, Space, Text } from '@billy/design-system'
import { ReactElement, useEffect, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { useSegment } from '../../../../hooks'
import { BillType } from '../../../bills/enums/billType'
import { useMultiplePayableSubjects } from '../../contexts'
import { getTypeFromPayableSubject } from '../../utils'
import { SubjectSummary } from '../SubjectSummary'
import { SubjectsList } from './elements/SubjectsList'
import { BillsListSkeleton } from './elements/SubjectsList/BillsListSkeleton'
import * as Styled from './styles'

export const MultipleSubjectsModalBody = (): ReactElement => {
  const { t } = useTranslation()
  const { track } = useSegment()
  const { subjects, isLoading, initialSubject } = useMultiplePayableSubjects()

  const isBill = useMemo(() => getTypeFromPayableSubject(initialSubject) === BillType.Bill, [initialSubject])

  useEffect(() => {
    const subjectKey = isBill ? 'bill' : 'invoice'
    track(`xxx - expenses - Multiple ${subjectKey} selection modal opened`, {
      subjectsCount: subjects?.length || 0,
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subjects?.length, initialSubject])

  const questionText = isBill
    ? t('bill.payment_reconcile.would_you_like_to_register_more_bills')
    : t('bill.payment_reconcile.would_you_like_to_register_more_invoices')

  return (
    <>
      <SubjectSummary />
      <Space />
      <Divider />
      <Space />
      <Text>{questionText}</Text>
      <Space />
      <Styled.BillsListWrapper>{isLoading ? <BillsListSkeleton /> : <SubjectsList />}</Styled.BillsListWrapper>
    </>
  )
}
